<template>
    <div>

        <div class="img-wrapper">
            <div class="overlay">
                <span>{{$t('Voir profil')}}<i class="fa-solid fa-arrow-right ms-2"></i></span>
            </div>
            <AssetLoader
                v-if="formateurData.imageId !== 0"
                :asset="{ asset: formateurData.imageId }"
                transform="?mode=crop&width=600&height=340"
            />
            <AssetLoader

                v-else-if="defaultImg.image.imageID !== null"
                :asset="{ asset: defaultImg.image.imageID}"
                transform="?mode=crop&width=600&height=340"
            />
        </div>

        <p v-if="formateurData.name" class="formateur-name text-weight-semibold mb-0">
            {{ formateurData.name }} allo
        </p>
        <p v-else class="formateur-name text-weight-semibold mb-0">
            <span v-if="formateurData.surname">{{ formateurData.surname }}</span>
            <span v-else>{{ formateurData.fName + ' ' + formateurData.lName }}</span>
        </p>
        <p class="text-legal">
            {{ formateurData.original.title }}
        </p>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import AssetLoader from '@/components/helpers/AssetLoader'

export default {
    name: 'FormateurCard',
    components: {
        AssetLoader,
    },
    props: {
        formateurData: {
            type: Object,
            required: true,
        },
        defaultImg: {
            type: Object,
            required: true,
        },

    },
    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
    methods: {
        ...mapActions(['setErrorsReportMsg']),
    },
    // On loaded...
    mounted() {},
}
</script>
